import { HStack, Image, VStack, Hide, Text, Checkbox, Stack } from '@chakra-ui/react'
import { SettingsIcon, CalendarIcon, ArrowBackIcon } from '@chakra-ui/icons'

import Clock from 'react-live-clock'
import { format } from 'date-fns'
import { RangeDatepicker } from 'chakra-dayzed-datepicker'
import ActionPopup from './ActionPopup'

const Header = ({
  lastUpdate,
  onShowSettingsModal,
  selectedDates,
  onSelectedDates,
  allReservations,
  onAllReservations,
  workendAction,
  setWorkendAction,
}: any) => {

  const leftSide = () => {
    if (window.location.href.includes('/reservations/calendar')) {
      return (
        <HStack>
          <ArrowBackIcon
            boxSize={6}
            color='white'
            cursor='pointer'
            _hover={{ color: 'green.400' }}
            onClick={() => (window.location.href = '/reservations')}
            mr={2}
          />
          <Checkbox
            colorScheme='white'
            color='white'
            isChecked={allReservations}
            onChange={onAllReservations}
            minWidth={140}
          >
            Include rooms
          </Checkbox>
        </HStack>
      )
    }

    if (window.location.href.includes('/reservations')) {
      return (
        <>
          <HStack mr={4}>
            <ArrowBackIcon
              boxSize={6}
              color='white'
              cursor='pointer'
              _hover={{ color: 'green.400' }}
              onClick={() => (window.location.href = '/')}
              mr={2}
            />
            <Checkbox
              colorScheme='white'
              color='white'
              isChecked={allReservations}
              onChange={onAllReservations}
              pr={2}
            >
              All
            </Checkbox>
            <CalendarIcon
              boxSize={6}
              color='white'
              cursor='pointer'
              _hover={{ color: 'green.400' }}
              onClick={() => (window.location.href = '/reservations/calendar')}
            />
          </HStack>
          <RangeDatepicker
            selectedDates={selectedDates}
            onDateChange={onSelectedDates}
            propsConfigs={{
              inputProps: {
                color: 'white',
                maxWidth: '240px',
              },
              dayOfMonthBtnProps: {
                isInRangeBtnProps: {
                  color: 'white',
                  background: 'blackAlpha.800',
                  border: 'none',
                  _hover: {
                    bg: 'green.400',
                  },
                },
                selectedBtnProps: {
                  color: 'white',
                  background: 'blackAlpha.800',
                  border: 'none',
                  _hover: {
                    bg: 'green.400',
                  },
                },
                defaultBtnProps: {
                  background: 'white',
                  border: 'none',
                  _hover: {
                    bg: 'green.400',
                    color: 'white',
                  },
                },
              },
              popoverCompProps: {
                popoverContentProps: {
                  rootProps: { background: 'red', zIndex: 99999 },
                },
              },
            }}
            configs={{
              dateFormat: 'yyyy-MM-dd',
              firstDayOfWeek: 1,
            }}
          />
        </>
      )
    }

    return (
      <>
        <CalendarIcon
          boxSize={6}
          color='white'
          cursor='pointer'
          _hover={{ color: 'green.400' }}
          onClick={() => (window.location.href = '/reservations')}
          mr={2}
        />
        <RangeDatepicker
          selectedDates={selectedDates}
          onDateChange={onSelectedDates}
          propsConfigs={{
            inputProps: {
              color: 'white',
              maxWidth: '240px',
            },
            dayOfMonthBtnProps: {
              isInRangeBtnProps: {
                color: 'white',
                background: 'blackAlpha.800',
                border: 'none',
                _hover: {
                  bg: 'green.400',
                },
              },
              selectedBtnProps: {
                color: 'white',
                background: 'blackAlpha.800',
                border: 'none',
                _hover: {
                  bg: 'green.400',
                },
              },
              defaultBtnProps: {
                background: 'white',
                border: 'none',
                _hover: {
                  bg: 'green.400',
                  color: 'white',
                },
              },
            },
            popoverCompProps: {
              popoverContentProps: {
                rootProps: { background: 'red', zIndex: 99999 },
              },
            },
          }}
          configs={{
            dateFormat: 'yyyy-MM-dd',
            firstDayOfWeek: 1,
          }}
        />
      </>
    )
  }

  return (
    <VStack minHeight={20} bg='blackAlpha.800' px={6} justifyContent='center'>
      <Stack
        w='full'
        justifyContent={{ base: 'space-between', lg: 'center' }}
        flexFlow='row'
        align='center'
        spacing={0}
      >
        {leftSide()}
        <Hide below='lg'>
          <Image src='/logo.png' maxWidth={200} position='absolute' />
          <VStack
            w='full'
            right={{ base: 0, md: 6 }}
            alignItems={{ base: 'center', md: 'flex-end' }}
            color='white'
            fontWeight='600'
            paddingRight='40px'
          >
            <Clock format={'YYYY-MM-DD HH:mm:ss'} ticking={true} timezone={'Europe/Vilnius'} />
            <HStack>
              <Text>Last Update:</Text>
              <Text color='green.400'>{format(lastUpdate, 'HH:mm:ss')}</Text>
            </HStack>
          </VStack>
          {workendAction && workendAction.id && (
            <ActionPopup
              action={workendAction}
              setAction={setWorkendAction}
              includeButton={true}
              fixed={true}
            ></ActionPopup>
          )}
        </Hide>
        {onShowSettingsModal && (
          <HStack position={{ base: 'relative', lg: 'absolute' }} right='20px'>
            <SettingsIcon
              boxSize={6}
              color='white'
              cursor='pointer'
              _hover={{ color: 'green.400' }}
              onClick={onShowSettingsModal}
            />
          </HStack>
        )}
      </Stack>
      <Hide above='lg'>
        <HStack
          w='full'
          alignItems='center'
          justifyContent='space-between'
          color='white'
          fontWeight='600'
        >
          <Clock format={'YYYY-MM-DD HH:mm:ss'} ticking={true} timezone={'Europe/Vilnius'} />
          <HStack>
            <Text>Updated:</Text>
            <Text color='green.400'>{format(lastUpdate, 'HH:mm:ss')}</Text>
          </HStack>
          {workendAction && workendAction.id && (
            <ActionPopup
              action={workendAction}
              setAction={setWorkendAction}
              includeButton={true}
            ></ActionPopup>
          )}
        </HStack>
      </Hide>
    </VStack>
  )
}

export default Header
